import React, { createContext, useContext, useState, useEffect } from "react";

const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  // Retrieve initial values from sessionStorage or set defaults
  const [device, setDevice] = useState(
    sessionStorage.getItem("device") || null,
  );
  const [deviceCode, setDeviceCode] = useState(
    sessionStorage.getItem("deviceCode") || null,
  );
  const [category, setCategory] = useState(
    sessionStorage.getItem("category") || null,
  );
  const [isDemoCategory, setIsDemoCategory] = useState(
    JSON.parse(sessionStorage.getItem("isDemoCategory")) || null,
  );
  const [product_id, setProductId] = useState(
    sessionStorage.getItem("product_id") || null,
  );
  const [mappedCategory, setMappedCategory] = useState(
    sessionStorage.getItem("mapped_category") || null,
  );
  const [project_id, setProjectId] = useState(
    sessionStorage.getItem("project_id") || null,
  );
  const [isCustomRecruitCategory, setIsCustomRecruitCategory] = useState(
    JSON.parse(sessionStorage.getItem("isCustomRecruitCategory")) || null,
  );
  const [isDualCategory, setIsDualCategory] = useState(
    JSON.parse(sessionStorage.getItem("isDualCategory")) || null,
  );
  const [showSidebar, setShowSidebar] = useState(true);
  // Save to sessionStorage whenever the state changes
  useEffect(() => {
    if (device !== null) {
      sessionStorage.setItem("device", device);
    }
  }, [device]);

  useEffect(() => {
    if (deviceCode !== null) {
      sessionStorage.setItem("deviceCode", deviceCode);
    }
  }, [deviceCode]);

  useEffect(() => {
    if (category !== null) {
      sessionStorage.setItem("category", category);
    }
  }, [category]);

  useEffect(() => {
    if (isDemoCategory !== null) {
      sessionStorage.setItem("isDemoCategory", isDemoCategory);
    }
  }, [isDemoCategory]);

  useEffect(() => {
    if (product_id !== null) {
      sessionStorage.setItem("product_id", product_id);
    }
  }, [product_id]);

  useEffect(() => {
    if (mappedCategory !== null) {
      sessionStorage.setItem("mapped_category", mappedCategory);
    }
  }, [mappedCategory]);

  useEffect(() => {
    if (project_id !== null) {
      sessionStorage.setItem("project_id", project_id);
    }
  }, [project_id]);

  const clearContext = () => {
    setDevice(null);
    setDeviceCode(null);
    setCategory(null);
    setIsDemoCategory(null);
    setProjectId(null);
    setProductId(null);
    setShowSidebar(true);
    setMappedCategory(null);
    setIsCustomRecruitCategory(null);
    setIsDualCategory(null);
  };

  return (
    <GlobalContext.Provider
      value={{
        device,
        setDevice,
        deviceCode,
        setDeviceCode,
        category,
        setCategory,
        isDemoCategory,
        setIsDemoCategory,
        isDualCategory,
        setIsDualCategory,
        isCustomRecruitCategory,
        setIsCustomRecruitCategory,
        product_id,
        setProductId,
        showSidebar,
        setShowSidebar,
        mappedCategory,
        setMappedCategory,
        setProjectId,
        project_id,
        clearContext,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => useContext(GlobalContext);
